import { render, staticRenderFns } from "./FormApi.vue?vue&type=template&id=164ed3c5&"
import script from "./FormApi.vue?vue&type=script&lang=js&"
export * from "./FormApi.vue?vue&type=script&lang=js&"
import style0 from "./FormApi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports